import { type IIconsVector } from 'shared/ui'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { type IAICallingType } from 'entities/AICalling/api/types'

type IAgentTemplate<T> = {
  type: T
  icon: IIconsVector
  name: string
  description: string
  isNew?: boolean
  isDisabled?: boolean
  isTypeChangeDisabled?: boolean
}

export type ITextingTemplate = IAgentTemplate<ChatbotInstructionType>
export type ICallingTemplate = IAgentTemplate<IAICallingType>

export const TextingTemplateMap = new Map<ChatbotInstructionType, ITextingTemplate>([
  [
    ChatbotInstructionType.Custom,
    {
      type: ChatbotInstructionType.Custom,
      icon: 'settings',
      name: 'Custom',
      description: 'Create a custom AI Agent with your instructions',
    },
  ],
  [
    ChatbotInstructionType.BookAppointment,
    {
      type: ChatbotInstructionType.BookAppointment,
      icon: 'calendar',
      name: 'Book Appointments',
      description: 'Let your AI agent schedule meetings',
      isNew: true,
      isTypeChangeDisabled: true,
    },
  ],
  [
    ChatbotInstructionType.FAQ,
    {
      type: ChatbotInstructionType.FAQ,
      icon: 'messageQuestion',
      name: 'FAQ / Information',
      description: 'Answer questions about your business or products',
    },
  ],
  [
    ChatbotInstructionType.LeadQualification,
    {
      type: ChatbotInstructionType.LeadQualification,
      icon: 'usersCheck',
      name: 'AI Data Collection',
      description: 'Gather essential information to qualify your leads',
    },
  ],
  [
    ChatbotInstructionType.Support,
    {
      type: ChatbotInstructionType.Support,
      icon: 'heart',
      name: 'Support',
      description: 'Handle customer and support requests',
    },
  ],
])

export const TextingTemplates = [...TextingTemplateMap.values()]

export const CallingTemplateMap: Record<IAICallingType, ICallingTemplate> = {
  custom: {
    type: 'custom',
    icon: 'settings',
    name: 'Custom',
    description: 'Create a custom AI Agent with your instructions',
  },
  faq_information: {
    type: 'faq_information',
    icon: 'messageQuestion',
    name: 'FAQ / Information',
    description: 'Answer questions about your business or products',
  },
  take_message: {
    type: 'take_message',
    icon: 'edit',
    name: 'Take Message',
    description: 'Capture caller details and their message',
  },
}

export const CallingTemplates = [...Object.values(CallingTemplateMap)]
